import { Overwrite } from "@utils/types";

export const $FlyoutCategoriesModuleName = "flyoutCategories";

export type TFlyoutCategoriesState = Overwrite<
    FlyoutCategory,
    {
        subCategories?: Array<FlyoutCategory>;
    }
>;

export type FlyoutCategory = {
    title: string;
    subCategories: Array<FlyoutCategory>;
    url: string;
};
